import { render } from "./PROPOSAL_TORCH_PASSED.vue?vue&type=template&id=523a00af"
import script from "./PROPOSAL_TORCH_PASSED.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_TORCH_PASSED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__